<template>
  <div class="fundoMenu">
    <slot></slot>
    <div class="menu">
      <nav class="navbar navbar-expand-md navbar-bytebank">
        <ul class="navbar-nav mr-auto">
          <li @mouseover="hover = menu.title" @mouseleave="hover = ''" class="nav-item" v-for="menu in menus" :key="menu.icon" :id="menu.id">
            <router-link
              v-tooltip.auto-start="menu.title"
              :class="`${getClassStyle()}`"
              :to="menu.path"
            >
              <i :class="menu.icon" :style="getIconStyle(menu.title, menu.styleTitulo)"></i>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    inFocus: { type: Boolean, required: false, default: true },
    isVisible: { type: Boolean, required: false, default: true }
  },

  methods: {
    getClassStyle () {
      let styleCustom = this.isVisible ? '' : 'disable '
      styleCustom += !this.inFocus ? 'opacity nav-link' : 'nav-link'
      return styleCustom
    },
    getIconStyle (title, style) {
      if (!this.inFocus) {
        return title === this.hover ? style : this.styleTitulo
      }
      return style
    }
  },

  data () {
    return {
      hover: '',
      styleTitulo: 'color: #757575;',
      menus: [
        {
          icon: 'fa fa-plus-square-o fa-1-7x',
          styleTitulo: 'color: #4a75b5; opacity: 1;',
          path: '/elaboracao/manter',
          title: 'Novo Protocolo',
          id: 'novo-protocolo'
        },
        {
          icon: 'fa fa-check-square-o fa-1-7x',
          styleTitulo: 'color: #4a75b5; opacity: 1;',
          path: '/receber',
          title: 'A Receber',
          id: 'a-receber'
        },
        {
          icon: 'fa fa-pencil-square-o fa-1-7x',
          styleTitulo: 'color: #4a75b5; opacity: 1;',
          path: '/elaboracao/consulta',
          title: 'Elaboração',
          id: 'elaboracao'
        },
        {
          icon: 'fa fa-folder-open-o fa-1-7x',
          styleTitulo: 'color: #4a75b5; opacity: 1;',
          path: '/setor',
          title: 'Setor',
          id: 'setor'
        },
        {
          icon: 'fa fa-user-o fa-1-7x',
          styleTitulo: 'color: #4a75b5; opacity: 1;',
          path: '/meus',
          title: 'Meus',
          id: 'meus'
        },
        {
          icon: 'fa fa-files-o fa-1-7x',
          styleTitulo: 'color: #4a75b5; opacity: 1;',
          path: '/reservados',
          title: 'Reservados',
          id: 'reservados'
        },
        {
          icon: 'fa fa-share-square-o fa-1-7x',
          styleTitulo: 'color: #4a75b5; opacity: 1;',
          path: '/tramitados',
          title: 'Tramitados',
          id: 'tramitados'
        },
        {
          icon: 'fa fa-globe fa-1-7x',
          styleTitulo: 'color: #4a75b5; opacity: 1;',
          path: '/buscaGeral',
          title: 'Busca Geral',
          id: 'busca-geral'
        },
        {
          icon: 'fa fa-home fa-1-7x',
          styleTitulo: 'color: #4a75b5; opacity: 1;',
          path: '/workArea',
          title: 'Work Area',
          id: 'work-area'
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/estiloGlobal.scss";

.fundoMenu {
  background: $backgroud-azul;
}

li a[class*='opacity'] {
  transition: all 0.3s ease-in-out;
}

.opacity {
  opacity: 0.3;
}

.menu {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.navbar {

  .navbar-bytebank a {
    color: #fff;
  }
  .navbar-bytebank a:hover {
    color: #000;
  }

  .navbar-nav > li {
    margin-right: 15px;
  }
}
</style>
